import { xor } from 'lodash';

export const getRowKey = (entry: any) => `row_key_${entry.name ?? entry.id}`;

export const getToggledKeys = (toggledKey: string, keys: string[]) => {
    return xor(keys, [toggledKey]);
};
